import { Common } from '@stockbit/ui';
import { SelectGroup, InputGroup } from '../../styled';
import OptionsGroup from './OptionsGroup';
import useValueMetrics from './useValueMetrics';

const { Flex } = Common;

interface InputMetricsProps {
  disabled?: boolean;
  metrics: string; // eps | growth
  selectValue: any;
  value: any;
  onChange: (e: any) => void;
  onSelect: (e: any) => void;
}

function InputMetrics({
  disabled,
  metrics: metricsKey,
  selectValue,
  value,
  onChange,
  onSelect,
}: InputMetricsProps) {
  const { metrics, getMetrics } = useValueMetrics();

  const options = metrics?.params?.[metricsKey] || [];

  return (
    <Flex>
      {metrics.params && (
        <SelectGroup
          value={selectValue === 0 ? getMetrics(metricsKey) : selectValue}
          onSelect={onSelect}
          style={{ minWidth: '50px' }}
          getPopupContainer={() => document.getElementById('sw-valuation-form')}
        >
          {options.map((item) => (
            <OptionsGroup value={item.fitem_id}>{item.fitem_name}</OptionsGroup>
          ))}
        </SelectGroup>
      )}
      <InputGroup onChange={onChange} disabled={disabled} value={value} />
    </Flex>
  );
}

export default InputMetrics;
